<script setup lang="ts">
const { direction = 'left' } = defineProps<{ direction?: 'left' | 'right' | 'up' | 'down' }>()
const baseAnimationClass = `transition duration-300`
const enterFromClass = {
    'left': 'translate-x-8',
    'right': '-translate-x-8',
    'up': '-translate-y-8',
    'down': 'translate-y-8'

}
const leaveToClass = {
    'left': '-translate-x-8',
    'right': 'translate-x-8',
    'up': 'translate-y-8',
    'down': '-translate-y-8'
}
</script>

<template>
    <Transition mode="out-in" :enter-active-class="baseAnimationClass"
        :enter-from-class="`opacity-0 ${enterFromClass[direction]}`" enter-to-class="opacity-100 translate-x-0"
        :leave-active-class="baseAnimationClass" leave-from-class="opacity-100 translate-x-0"
        :leave-to-class="`opacity-0 ${leaveToClass[direction]}`">
        <slot />
    </Transition>
</template>